export enum NoteArticleType {
  BY_ARTICLE = 0,
  BY_TOTAL = 1,
}
